import { Button, Card, Typography, Alert, Space } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useMutation } from 'react-query';
import httpService from 'services/http.service';
import { API_URLS } from 'config/constants';

const { Title, Text } = Typography;

const API_DOMAIN = 'https://api.bibikalka.com.ua';

async function generateFeed(): Promise<{ uaCount: number; ruCount: number; promCount: number }> {
  const { data } = await httpService.post(API_URLS.FEED.GENERATE);
  return data;
}

const FeedPage = () => {
  const [result, setResult] = useState<{ uaCount: number; ruCount: number; promCount: number } | null>(null);

  const { mutate, isLoading, isError, error } = useMutation(generateFeed, {
    onSuccess: (data) => setResult(data),
  });

  return (
    <Card style={{ maxWidth: 600, margin: '24px auto' }}>
      <Title level={4}>Google Shopping Feed</Title>

      <Space direction='vertical' size='middle' style={{ width: '100%' }}>
        <Text type='secondary'>
          Генерує UA, RU та Prom.ua фіди і зберігає їх у
          {' '}
          <code>public/feed/</code>
          . Після генерації фіди доступні за посиланнями. Prom-фід також
          автоматично оновлюється щогодини після синку залишків Toysi.
        </Text>

        <Space direction='vertical' size={4}>
          <a href={`${API_DOMAIN}/public/feed/google.feed.xml`} target='_blank' rel='noreferrer'>
            {`${API_DOMAIN}/public/feed/google.feed.xml`}
          </a>
          <a href={`${API_DOMAIN}/public/feed/google-feed-ru.xml`} target='_blank' rel='noreferrer'>
            {`${API_DOMAIN}/public/feed/google-feed-ru.xml`}
          </a>
          <a href={`${API_DOMAIN}/public/feed/prom.feed.xml`} target='_blank' rel='noreferrer'>
            {`${API_DOMAIN}/public/feed/prom.feed.xml`}
          </a>
        </Space>

        <Button
          type='primary'
          icon={<SyncOutlined />}
          loading={isLoading}
          onClick={() => { setResult(null); mutate(); }}
          size='large'
        >
          Generate Feed
        </Button>

        {result && (
          <Alert
            type='success'
            message='Фід успішно згенеровано!'
            description={`UA: ${result.uaCount} товарів · RU: ${result.ruCount} товарів · Prom: ${result.promCount} товарів`}
            showIcon
          />
        )}

        {isError && (
          <Alert
            type='error'
            message='Помилка генерації'
            description={(error as any)?.message || 'Невідома помилка'}
            showIcon
          />
        )}
      </Space>
    </Card>
  );
};

export default FeedPage;
